// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__3cjhY","search":"Settings_search__aUwhc","filter":"Settings_filter__1Sy5u"};